import script from "./Textarea.vue?vue&type=script&lang=ts&setup=true"
export * from "./Textarea.vue?vue&type=script&lang=ts&setup=true"

import "./Textarea.vue?vue&type=style&index=0&id=51a61ff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51a61ff6"]])

export default __exports__